import { useCallback } from "react"
import {
  Block,
  LabelLarge,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { setOnboardingFlow, setOpenModal, useDappDispatch } from "#/redux-state"
import {
  usePosthogOnboardingEvent,
  usePosthogSignUpEvent,
} from "#/shared/hooks/posthog-events"
import { OnboardingFlow, PosthogAnalyticsId } from "#/shared/types"

export default function OnboardingModalFooter() {
  const { emitSignUpStartedEvent } = usePosthogSignUpEvent()
  const { emitOnboardingButtonClickedEvent } = usePosthogOnboardingEvent()

  const dispatch = useDappDispatch()
  const [css, theme] = useStyletron()

  const signUpWithWalletHandler = useCallback(() => {
    emitSignUpStartedEvent()
    emitOnboardingButtonClickedEvent(PosthogAnalyticsId.ONBOARDING_SIGNUP)
    dispatch(setOnboardingFlow(OnboardingFlow.SIGN_UP))
    dispatch(setOpenModal("wallet-connect"))
  }, [dispatch, emitSignUpStartedEvent, emitOnboardingButtonClickedEvent])

  return (
    <Block
      className={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      })}
    >
      <ParagraphLarge>Don&apos;t have an account? </ParagraphLarge>
      <LabelLarge
        onClick={signUpWithWalletHandler}
        as="button"
        className={css({
          textDecoration: "underline",
          margin: `${theme.sizing.scale600} 0`,
        })}
      >
        Sign up
      </LabelLarge>
    </Block>
  )
}
